import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const InSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.70694 8.70703L7.41394 11L15.9999 11V13L7.41394 13L9.70694 15.293L8.29294 16.707L3.58594 12L8.29294 7.29303L9.70694 8.70703Z" fill="currentColor" />
    <path
      d="M22 21H20C19.4696 21 18.9609 20.7893 18.5858 20.4142C18.2107 20.0391 18 19.5304 18 19L18 5C18 4.46957 18.2107 3.96086 18.5858 3.58579C18.9609 3.21071
      19.4696 3 20 3H22C22.5304 3 23.0391 3.21071 23.4142 3.58579C23.7893 3.96086 24 4.46957 24 5L24 19C24 20.103 23.104 21 22 21ZM21.997 5L20 5L20 19H22L21.997 5Z"
      fill="currentColor"
    />
  </svg>
);

const In = (props: IIconProps) => <Icon component={InSvg} {...props} />;

export default In;
